// src/utils.ts
export const formatDuration = (start: number | null) => {
    if (!start) return "00:00";
    const duration = (Date.now() - start) / 1000;
    const min = Math.floor(duration / 60);
    const sec = Math.floor(duration % 60);
    return `${min.toString().padStart(2, "0")}:${sec.toString().padStart(2, "0")}`;
  };
  
  // Helper function to parse HTML tags and convert to React elements
  export const parseAnalysisContent = (content: string) => {
    // Replace HTML-like spans with styled spans
    const processedContent = content
      .replace(/<span class="critical-info">(.*?)<\/span>/g, '<span style="background-color: #ffebee; color: #c62828; font-weight: bold; padding: 2px 4px; border-radius: 3px;">$1</span>')
      .replace(/<span class="vital-sign">(.*?)<\/span>/g, '<span style="background-color: #e8f5e8; color: #2e7d32; font-weight: bold; padding: 2px 4px; border-radius: 3px;">$1</span>')
      .replace(/<span class="medication">(.*?)<\/span>/g, '<span style="background-color: #fff3e0; color: #f57c00; font-weight: bold; padding: 2px 4px; border-radius: 3px;">$1</span>')
      .replace(/<span class="assessment">(.*?)<\/span>/g, '<span style="background-color: #e3f2fd; color: #1976d2; font-weight: bold; padding: 2px 4px; border-radius: 3px;">$1</span>');
  
    return processedContent;
  };